let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hI11K")).then(() => parcelRequire('9XsDd'));